import { render, staticRenderFns } from "./statisData.vue?vue&type=template&id=f8f5b11a&scoped=true"
import script from "./statisData.vue?vue&type=script&lang=js"
export * from "./statisData.vue?vue&type=script&lang=js"
import style0 from "./statisData.vue?vue&type=style&index=0&id=f8f5b11a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8f5b11a",
  null
  
)

export default component.exports